import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      isAuthenticated: 'user/isAuthenticated',
      currentUser: 'user/currentUser',
      userRights: 'user/userRights',
    }),
    
    // Add some common computed properties that components might need
    userId() {
      return this.$store.state.user.userID;
    },
    
    businessId() {
      return this.$store.state.user.businessID;
    },
    
    isLoggedIn() {
      return this.$store.state.user.isLoggedIn;
    }
  },
  
  methods: {
    hasRight(right) {
      return this.$store.getters['user/hasUserRight'](right);
    },
    
    logout() {
      this.$store.dispatch('user/logout');
      this.$router.push({ name: 'auth-login-v2' });
    }
  }
} 